import { SvgIcon, SvgIconProps } from "@mui/material";

export default ({
  color,
  ...props
}: Omit<SvgIconProps, "color"> & { color?: string }) => (
  <SvgIcon height="24px" viewBox="-225 -50 960 960" width="24px" {...props}>
    <path
      fill={color}
      d="M 507.607 263.705 L 413.107 263.705 A 366.44 366.44 0 0 0 402.173 214.173 Q 394.777 189.526 384.228 169.866 A 165.573 165.573 0 0 0 363.157 139.055 A 121.976 121.976 0 0 0 273.873 96.516 A 163.548 163.548 0 0 0 265.507 96.305 Q 181.807 96.305 142.207 163.805 A 227.762 227.762 0 0 0 120.691 215.522 Q 105.314 268.394 103.012 346.23 A 953.692 953.692 0 0 0 102.607 374.405 Q 102.607 497.812 130.384 564.995 A 195.94 195.94 0 0 0 139.957 585.005 Q 177.307 652.505 257.407 652.505 A 135.6 135.6 0 0 0 301.249 645.716 A 112.999 112.999 0 0 0 350.107 612.905 A 161.762 161.762 0 0 0 375.951 572.227 Q 390.234 540.821 396.907 497.705 L 491.407 497.705 A 433.328 433.328 0 0 1 482.446 562.138 Q 474.768 596.84 461.315 625.656 A 256.793 256.793 0 0 1 457.207 634.055 A 213.003 213.003 0 0 1 414.578 691.96 A 193.504 193.504 0 0 1 377.557 719.555 Q 326.707 748.805 257.407 748.805 A 280.972 280.972 0 0 1 177.363 738.047 A 204.43 204.43 0 0 1 64.357 655.655 A 302.578 302.578 0 0 1 26.416 576.441 Q 1.709 500.162 0.117 389.777 A 1065.704 1065.704 0 0 1 0.007 374.405 A 860.914 860.914 0 0 1 5.24 276.11 Q 18.612 160.107 66.157 93.155 Q 132.307 0.005 265.507 0.005 A 284.404 284.404 0 0 1 326.692 6.288 A 215.069 215.069 0 0 1 389.707 30.605 A 207.953 207.953 0 0 1 462.097 102.425 A 255.885 255.885 0 0 1 472.057 120.155 Q 502.207 179.105 507.607 263.705 Z"
      vectorEffect="non-scaling-stroke"
    />

    <line
      strokeWidth="50"
      x1="535"
      x2="-25"
      y1="800"
      y2="800"
      stroke={color}
      strokeDasharray="0,90"
      strokeLinecap="round"
    />
  </SvgIcon>
);
